import React from "react"

/**
 * A minimal, data-free page that any authenticated user (admin or member) can access.
 *
 * Its only responsibility is to act as a safe landing page after authentication
 * so that the AuthenticatedRoute provider can decide whether to redirect the
 * user to onboarding. Once the provider signals that the user is fully
 * onboarded, we can optionally steer admins to their normal home page.
 */
function LoadingPortal() {
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-white">
      <p className="animate-pulse text-sm text-gray-500">Loading&nbsp;…</p>
    </div>
  )
}

export default LoadingPortal
